// Common
export const DAMGA_VERGISI_ORANI = 0.00759;
export const BASVURU_HARCI = 615.4;
export const VEKALET_PULU = 138;
export const VEKALET_SURET_HARCI = 87.5;
export const TEBLIGAT_OPTIONS = [
    { text: "Normal Tebligat", value: 210 },
    { text: "Hızlı Tebligat", value: 420 },
    { text: "E-tebligat", value: 15 }
];


// Anasayfa
export const SEARCH_OPTIONS = [
    { text: "Yıllık İzin Süresi Hesapla", href: "/hesaplamalar/yillik-izin-suresi-hesaplama" },
    { text: "Islah Harcı Hesapla", href: "/hesaplamalar/islah-harci-hesaplama" },
    { text: "Tapu Harcı Hesapla", href: "/hesaplamalar/tapu-harci-hesaplama" },
    { text: "Fazla Çalışma Hesapla", href: "/hesaplamalar/fazla-calisma-hesaplama" },
    { text: "Kıdem Tazminatı Hesapla", href: "/hesaplamalar/kidem-tazminati-hesaplama" },
    { text: "Tahliye Taahhütnamesine Dayalı İcra Hesapla", href: "/hesaplamalar/tahliye-taahhutnamesine-dayali-icra-hesaplama" },
    { text: "Araç Değer Kaybı Hesapla", href: "/hesaplamalar/arac-deger-kaybi-hesaplama" },
    { text: "İcra Masrafı Hesapla", href: "/hesaplamalar/icra-masrafi-hesaplama" },
    { text: "İhbar Tazminatı Hesapla", href: "/hesaplamalar/ihbar-tazminati-hesaplama" },
    { text: "Bilirkişi Asgari Tarifeleri", href: "/hesaplamalar/bilirkisi-asgari-tarifeleri" },
    { text: "İş Günü Hesapla", href: "/hesaplamalar/is-gunu-hesaplama" },
    { text: "Askerlik Borçlanması Hesapla", href: "/hesaplamalar/askerlik-borclanmasi-hesaplama" },
    { text: "Vekalet Ücreti Hesapla", href: "/hesaplamalar/vekalet-ucreti-hesaplama" },
    { text: "Mahkeme Harç ve Gider Hesaplama", href: "/hesaplamalar/mahkeme-harc-ve-gider-hesaplama" },
];


// Araç Değer Kaybı
export const ARAC_DEGER_OPTIONS = [
	{ text: "0 - 15.000", value: 0.9 },
	{ text: "15.000 - 30.000", value: 0.8 },
	{ text: "30.000 - 45.000", value: 0.6 },
	{ text: "45.000 - 60.000", value: 0.4 },
	{ text: "60.000 - 75.000", value: 0.3 },
	{ text: "75.000 - 150.000", value: 0.2 },
	{ text: "150.000 ve üzeri", value: 0.1 },
];

export const ARAC_DEGER_HASAR_BOYUTLARI = [
	{ text: "Büyük Hasar (A1)", value: 0.9 },
	{ text: "Orta Hasar (A2)", value: 0.75 },
	{ text: "Küçük Hasar (A3)", value: 0.5 },
	{ text: "Basit Hasar (A4)", value: 0.25 },
];


// Askerlik Borçlanması
export const ASKERLIK_ASGARI = 26005.5;
export const ASKERLIK_TABAN_KATSAYISI = 0.32;
export const ASKERLIK_TAVAN_KATSAYISI = 7.5;


// Bilirkişi Asgari
export const BILIRKISI_FEES = [
    { type: "İcra ve iflas daireleri ile satış memurluklarında görülen işler için", amount: 1600 },
    { type: "Sulh hukuk ve tüketici mahkemelerinde görülen dava ve işler için", amount: 1600 },
    { type: "İcra hukuk ve icra ceza mahkemelerinde görülen dava ve işler için", amount: 1600 },
    { type: "Asliye hukuk mahkemelerinde görülen dava ve işler için", amount: 2700 },
    { type: "Aile, iş ve kadastro mahkemelerinde görülen dava ve işler için", amount: 2100 },
    { type: "Asliye ticaret ile fikri ve sınaî haklar mahkemelerinde görülen dava ve işler için", amount: 3200 },
    { type: "İdare ve vergi mahkemelerinde görülen dava ve işler için", amount: 2700 },
    { type: "Cumhuriyet başsavcılıklarında yürütülen soruşturmalar için", amount: 1600 },
    { type: "Sulh ceza hâkimliklerinde görülen işler için", amount: 1600 },
    { type: "Asliye ceza mahkemelerinde görülen dava ve işler için", amount: 2700 },
    { type: "Ağır ceza mahkemelerinde görülen dava ve işler için", amount: 3200 },
    { type: "Bölge adliye ve bölge idare mahkemelerinde görülen dava ve işler için", amount: 3400 },
    { type: "Yargıtay ve Danıştay’da ilk derece mahkemesi sıfatıyla görülen dava ve işler için", amount: 4200 },
];


// İhbar Tazminatı
export const IHBAR_VERGI_ARALIGI = [
    { min: 0, max: 70000, rate: 0.15 },
    { min: 70000, max: 150000, rate: 0.2 },
    { min: 150000, max: 370000, rate: 0.27 },
    { min: 370000, max: 1900000, rate: 0.35 },
    { min: 1900000, max: 999999999, rate: 0.4 },
];


// Kıdem Tazminatı
export const KIDEM_TAVAN_UCRETLERI = [
    { tarih: new Date('2005-06-30'), tutar: 1648.9 },
    { tarih: new Date('2005-12-31'), tutar: 1727.2 },
    { tarih: new Date('2006-06-30'), tutar: 1770.6 },
    { tarih: new Date('2006-12-31'), tutar: 1857.4 },
    { tarih: new Date('2007-06-30'), tutar: 1960.7 },
    { tarih: new Date('2007-12-31'), tutar: 2030.2 },
    { tarih: new Date('2008-06-30'), tutar: 2087.9 },
    { tarih: new Date('2008-12-31'), tutar: 2173.2 },
    { tarih: new Date('2009-06-30'), tutar: 2260.1 },
    { tarih: new Date('2009-12-31'), tutar: 2365.2 },
    { tarih: new Date('2010-06-30'), tutar: 2427.0 },
    { tarih: new Date('2010-12-31'), tutar: 2517.0 },
    { tarih: new Date('2011-06-30'), tutar: 2623.2 },
    { tarih: new Date('2012-06-30'), tutar: 2917.3 },
    { tarih: new Date('2012-12-31'), tutar: 3034.0 },
    { tarih: new Date('2013-06-30'), tutar: 3129.3 },
    { tarih: new Date('2013-12-31'), tutar: 3254.4 },
    { tarih: new Date('2014-12-31'), tutar: 3438.2 },
    { tarih: new Date('2015-06-30'), tutar: 3541.4 },
    { tarih: new Date('2015-08-31'), tutar: 3710.0 },
    { tarih: new Date('2015-12-31'), tutar: 3828.4 },
    { tarih: new Date('2016-06-30'), tutar: 4092.5 },
    { tarih: new Date('2016-12-31'), tutar: 4297.2 },
    { tarih: new Date('2017-06-30'), tutar: 4426.2 },
    { tarih: new Date('2017-12-31'), tutar: 4732.5 },
    { tarih: new Date('2018-06-30'), tutar: 5001.8 },
    { tarih: new Date('2018-12-31'), tutar: 5434.4 },
    { tarih: new Date('2019-06-30'), tutar: 6017.6 },
    { tarih: new Date('2019-12-31'), tutar: 6379.9 },
    { tarih: new Date('2020-06-30'), tutar: 6730.2 },
    { tarih: new Date('2020-12-31'), tutar: 7117.2 },
    { tarih: new Date('2021-06-30'), tutar: 7639.0 },
    { tarih: new Date('2021-12-31'), tutar: 8284.5 },
    { tarih: new Date('2022-06-30'), tutar: 10848.6 },
    { tarih: new Date('2022-12-31'), tutar: 15371.4 },
    { tarih: new Date('2023-06-30'), tutar: 19982.8 },
    { tarih: new Date('2023-12-31'), tutar: 23489.8 },
    { tarih: new Date('2024-06-30'), tutar: 35058.58 },
    { tarih: new Date('2024-12-31'), tutar: 41828.42 },
    { tarih: new Date('2025-06-30'), tutar: 46655.43 },
];


// Mahkeme Harç ve Gider
export const DELIL_TESPITI_HARCI = 1013.9;
export const YURUTMENIN_DURDURULMASI_HARCI = 1013.9;
export const BASVURU_HARCI_ICRA_SULH = 281.8;
export const KARAR_HARCI_SABIT = 615.4;
export const POSTA_MASRAFI_TEMEL = 2100;
export const TARAF_SAYISI_POSTA_UCRET_ARTISI = 1050;
export const DURUSMA_MASRAFI_TARAF_SAYISI_UCRET_ARTISI = 420;
export const DURUSMA_MASRAFI_TARAF_SAYISI_TEMEL_UCRETI = 420;
export const PESIN_HARC_TEMEL = 2500;
export const HARC_ORANI = 0.0170775;
export const PESIN_HARC_TARAF_SAYISI_UCRET_ARTISI = 1050;
export const GIDER_AVANSI_TEMEL = 615.4;

export const MAHKEMELER = [
    { value: 1, text: "İdare Mahkemesi" },
    { value: 2, text: "Vergi Mahkemesi"},
    { value: 3, text: "Aile Mahkemesi" },
    { value: 4, text: "Asliye Hukuk Mahkemesi" },
    { value: 5, text: "Asliye Ticaret Mahkemesi" },
    { value: 6, text: "Denizcilik İhtisas Mahkemesi", },
    { value: 7, text: "Fikri ve Sınai Haklar Mahkemesi" },
    { value: 8, text: "İcra Mahkemesi" },
    { value: 9, text: "Kadastro Mahkemesi" },
    { value: 10, text: "Sulh Hukuk Mahkemesi" },
    { value: 11, text: "Tüketici Mahkemesi", },
    { value: 12, text: "İş Mahkemesi" },
];

// Vekalet Ücreti
export const VEKALET_MINIMUM_COST = 6000;
export const VEKALET_MINIMUM_LIMIT = 37500;

export const KONUSU_PARA_OLMAYAN_MAHKEMELER = [
    { id: 1, text: "Ağır Ceza Mahkemesi", value: 48000 },
    { id: 2, text: "Anayasa Mahkemesinde Yüce Divan Sıfatıyla Bakılan Davalar", value: 90000 },
    { id: 3, text: "Anayasa Mahkemesindeki Diğer Davalar", value: 65000 },
    { id: 4, text: "Aile Mahkemesi", value: 30000 },
    { id: 5, text: "Asliye Ceza Mahkemesi", value: 30000 },
    { id: 6, text: "Asliye Hukuk Mahkemesi", value: 30000 },
    { id: 7, text: "Çocuk Ağır Mahkemesi", value: 48000 },
    { id: 8, text: "Çocuk Mahkemesi", value: 30000 },
    { id: 9, text: "Danıştayda İlk Derecede Görülen Duruşmalı Davalar", value: 28000 },
    { id: 10, text: "Danıştayda İlk Derecede Görülen Duruşmasız Davalar", value: 56000 },
    { id: 11, text: "Denizcilik İhtisas Mahkemesi", value: 30000 },
    { id: 12, text: "Fikri ve Sınai Haklar Mahkemesi", value: 40000 },
    { id: 13, text: "İcra Hukuk Mahkemesi", value: 12000 },
    { id: 14, text: "İdare ve Vergi Mahkemesi (Duruşmasız)", value: 18000 },
    { id: 15, text: "İdare ve Vergi Mahkemesi (Duruşmalı)", value: 36000 },
    { id: 16, text: "Kadastro Mahkemesi", value: 30000 },
    { id: 17, text: "Sayıştayda Görülen Duruşmasız Davalar", value: 24000 },
    { id: 18, text: "Sayıştayda Görülen Duruşmalı Davalar", value: 46500 },
    { id: 19, text: "Sulh Ceza Mahkemesi", value: 13500 },
    { id: 20, text: "Sulh Hukuk Mahkemesi", value: 18000 },
    { id: 21, text: "Tüketici Mahkemesi", value: 15000 },
    { id: 22, text: "Yargıtayda İlk Derecede Görülen Davalar", value: 46500 }
];

export const KONUSU_PARA_OLAN_MAHKEMELER = [
    { id: 1, text: "Aile Mahkemesi", value: 30000 },
    { id: 2, text: "Asliye Ticaret Mahkemesi", value: 30000 },
    { id: 3, text: "Asliye Hukuk Mahkemesi", value: 30000 },
    { id: 4, text: "Denizcilik İhtisas Mahkemesi", value: 30000 },
    { id: 5, text: "Fikri ve Sınai Haklar Mahkemesi", value: 40000 },
    { id: 6, text: "İcra Hukuk Mahkemesi", value: 12000 },
    { id: 7, text: "İş Mahkemesi", value: 30000 },
    { id: 8, text: "Kadastro Mahkemesi", value: 30000 },
    { id: 9, text: "Sulh Hukuk Mahkemesi", value: 18000 },
    { id: 10, text: "Tüketici Mahkemesi", value: 15000 }
];

export const DIGER_MAHKEMELER = [
    { id: 1, text: "Anayasa Mahkemesine Duruşmalı Bireysel Başvuru", value: 60000 },
    { id: 2, text: "Anayasa Mahkemesine Duruşmasız Bireysel Başvuru", value: 30000 },
    { id: 3, text: "Bölge Adliye / İdare Mahkemesinde İlk Derecede Görülen İşler", value: 25000 },
    { id: 4, text: "Bölge Adliye / İdare Mahkemesindeki Bir Duruşmalı Dava", value: 16000 },
    { id: 5, text: "Bölge Adliye / İdare Mahkemesindeki Birden Fazla Duruşmalı Davalar", value: 32000 },
    { id: 6, text: "Ceza Soruşturmasına İlişkin İşlemler", value: 8000 },
    { id: 7, text: "İcra Mahkemelerinde Takip Edilen Ceza İşleri", value: 10000 },
    { id: 8, text: "İcra Mahkemelerinde Takip Edilen Duruşmalı İşleri", value: 12000 },
    { id: 9, text: "İcra Mahkemelerinde Takip Edilen Diğer İşleri", value: 7000 },
    { id: 10, text: "Tahliyeye İlişkin İcra Takipleri", value: 13500 },
    { id: 11, text: "Yargıtay, Danıştay ve Sayıştayda Temyiz Yoluyla Görülen Davaların Duruşması", value: 28000 }
];

export const VEKALET_VERGI_ARALIGI = [
    { min: 0, max: 400_000, rate: 0.16 },
    { min: 400_000, max: 800_000, rate: 0.15 },
    { min: 800_000, max: 1_600_000, rate: 0.14 },
    { min: 1_600_000, max: 2_800_000, rate: 0.11 },
    { min: 2_800_000, max: 4_400_000, rate: 0.08 },
    { min: 4_400_000, max: 6_400_000, rate: 0.05 },
    { min: 6_400_000, max: 8_800_000, rate: 0.03 },
    { min: 8_800_000, max: 11_600_000, rate: 0.02 },
    { min: 11_600_000, max: Number.MAX_VALUE, rate: 0.01 },
];
